var map = {
	"./bgtheme/Origami Repetika - 4c Iced Tea.aac": 4595,
	"./bgtheme/SOS amb_doomdrones_mood_repeater_04.fix.mp3": 9613,
	"./bgtheme/Zane Little - It Takes A Hero.aac": 7180,
	"./bgtheme/Zane Little - Post-Adventure Tea Party.aac": 2739,
	"./bgtheme/Zane Little - Sinister Abode.aac": 978,
	"./bonus/333404__jayfrosting__cheer-2.wav.mp3": 6092,
	"./bonus/345086__metrostock99__oh-yeah-low-4.wav.mp3": 6123,
	"./bonus/681458__supersouper__yeah-cheering.wav.mp3": 365,
	"./bonus/G4F SFX05 - Casual - MA3 sfx_voice_woohoo_02.fix.mp3": 6218,
	"./boo/239900__thesubber13__scream-1.mp3": 1240,
	"./boo/335906__littlerainyseasons__fail.mp3": 2525,
	"./boo/339309__kalibrk__jirkascream.mp3": 2323,
	"./boo/348270__metekavruk__oops2.mp3": 5710,
	"./boo/353925__dr_skitz__boo.mp3": 2911,
	"./boo/558735__samsterbirdies__8-bit-fail.mp3": 2687,
	"./boo/563850__nikplaymostories__fail-trombone-wah-wah-wah-sound-effect.mp3": 8998,
	"./boo/687017__robinhood76__11575-male-group-booing.mp3": 3329,
	"./flipboard/Cartoon & Toy SFX - Cartoon Machine 03.fix.mp3": 7986,
	"./flipboard/Clock 023.fix.mp3": 2927,
	"./flipboard/Flexatone_Quiver_09.fix.mp3": 3343,
	"./flipboard/Flourish,lousymachine,trial,failure,chunky,engage.fix.mp3": 564,
	"./flipboard/Riffeling_Playing_Cards_on_Cardboard_4.fix.mp3": 5561,
	"./flipboard/SHAKER Pieces Drop Roll 01.fix.mp3": 3368,
	"./flipboard/Scatter Plops 04.fix.mp3": 9160,
	"./flipboard/StartSelect,UI,set57,camera mechanics,servo,clicks clacks,meaty,operative,forward.fix.mp3": 8453,
	"./flipboard/Wood Rattle 10.fix.mp3": 7412,
	"./misc/5366 - Space Lift Door 02.fix.mp3": 4005,
	"./misc/Boom 005.fix.mp3": 1329,
	"./misc/Boom 036.fix.mp3": 5531,
	"./misc/Boom 091.fix.mp3": 5982,
	"./misc/COINS Collect Jackpot Win 03.fix.mp3": 4086,
	"./misc/Glitch_Factory_01_Boom_Crackle_04.fix.mp3": 4460,
	"./misc/Harp_Glissando_10b.fix.mp3": 7139,
	"./misc/LV-HTIS Beeps Synth 02.fix.mp3": 6313,
	"./misc/LV-HTIS Power Down 01.fix.mp3": 1716,
	"./misc/Laser-Like_Synth_Basic_Laser4_08.fix.mp3": 3737,
	"./misc/Magic_Spells_CastShort_Water_General07.fix.mp3": 8302,
	"./misc/Magic_Teleport.fix.mp3": 3540,
	"./misc/Male Warrior 2 Scream, Battle, War, Cry, Fight, Shout 3.fix.mp3": 7373,
	"./misc/NEGATIVE Failure Descending Chime 05.fix.mp3": 1641,
	"./misc/PM_FN_Events_LvlUps_PowerUps_25.fix.mp3": 5506,
	"./misc/Power Whoosh Large 05.fix.mp3": 7238,
	"./misc/PowerUp01.fix.mp3": 128,
	"./misc/SOS 033.fix.mp3": 1022,
	"./misc/SUCCESS CHEERS Win Cute Vocal Chime 03.fix.mp3": 9419,
	"./misc/Swoosh_Rope_Whip_075.fix.mp3": 5765,
	"./misc/Weapon Shot Blaster-06.fix.mp3": 3487,
	"./misc/Whoosh_Bungee_Exercise_Rope.fix.mp3": 1743,
	"./misc/ZITHER Tone 15.fix.mp3": 861,
	"./misc/dark impacts.fix.mp3": 6064,
	"./misc/marimba_tone_007.fix.mp3": 6203,
	"./misc/slotcounter1.mp3": 155,
	"./misc/slotcounter2.mp3": 5716,
	"./misc/wah_short_C_001.fix.mp3": 4804,
	"./nextpuzzle/POP Echo Bouncer 01.fix.mp3": 7033,
	"./rightword/SUCCESS BEEPS Multi Echo Short 02.fix.mp3": 69,
	"./rightword/SUCCESS PICKUP Collect Chime 01.fix.mp3": 6499,
	"./rightword/collect_item_14.fix.mp3": 6357,
	"./startgame/Action B.fix.mp3": 2305,
	"./startgame/Justice B.fix.mp3": 544,
	"./timeout/collect_item_hurry_out_of_time_01.fix.mp3": 1202,
	"./timer/buzzer.mp3": 1235,
	"./timer/clocktick-even-hi.mp3": 5513,
	"./timer/clocktick-even.mp3": 7655,
	"./timer/clocktick-odd-hi.mp3": 1442,
	"./timer/clocktick-odd.mp3": 6850,
	"./tts/justsaying-allowexplain.mp3": 669,
	"./tts/justsaying-almostchances.mp3": 7538,
	"./tts/justsaying-attention.mp3": 1897,
	"./tts/justsaying-behasty.mp3": 3991,
	"./tts/justsaying-decentwork.mp3": 4549,
	"./tts/justsaying-donequitewell.mp3": 7857,
	"./tts/justsaying-faireffort.mp3": 2509,
	"./tts/justsaying-figureeventually.mp3": 4694,
	"./tts/justsaying-firstrate.mp3": 9987,
	"./tts/justsaying-gotthere.mp3": 6849,
	"./tts/justsaying-hatsoffwelldone.mp3": 5986,
	"./tts/justsaying-jollygood.mp3": 810,
	"./tts/justsaying-likewheregoing.mp3": 825,
	"./tts/justsaying-listenlearn.mp3": 5102,
	"./tts/justsaying-missedmark.mp3": 1449,
	"./tts/justsaying-mostsatisfactory.mp3": 1150,
	"./tts/justsaying-noreasonatall.mp3": 1704,
	"./tts/justsaying-notbadatall.mp3": 8383,
	"./tts/justsaying-notbesteffort.mp3": 3544,
	"./tts/justsaying-notbestnotworst.mp3": 2302,
	"./tts/justsaying-nothingproud.mp3": 9922,
	"./tts/justsaying-notimpressed.mp3": 8207,
	"./tts/justsaying-notmad.mp3": 8586,
	"./tts/justsaying-nottooshabby.mp3": 5453,
	"./tts/justsaying-notuptoscratch.mp3": 9094,
	"./tts/justsaying-notyet.mp3": 4610,
	"./tts/justsaying-offthemark.mp3": 3605,
	"./tts/justsaying-ohdear.mp3": 9944,
	"./tts/justsaying-payattention.mp3": 3569,
	"./tts/justsaying-pencilsdown.mp3": 145,
	"./tts/justsaying-pocketlight.mp3": 4037,
	"./tts/justsaying-poorshowing.mp3": 7722,
	"./tts/justsaying-quitelacking.mp3": 1954,
	"./tts/justsaying-quitenicely.mp3": 4231,
	"./tts/justsaying-ratherdissappointing.mp3": 7017,
	"./tts/justsaying-ratherpleased.mp3": 2643,
	"./tts/justsaying-ratherunfortunate.mp3": 2488,
	"./tts/justsaying-remarkableeffort.mp3": 5439,
	"./tts/justsaying-sadforyou.mp3": 8853,
	"./tts/justsaying-seenanymovies.mp3": 7477,
	"./tts/justsaying-smashingjob.mp3": 1858,
	"./tts/justsaying-splendidoutcome.mp3": 688,
	"./tts/justsaying-taughtverywell.mp3": 1564,
	"./tts/justsaying-thathappened.mp3": 2485,
	"./tts/justsaying-thisisgame.mp3": 1747,
	"./tts/justsaying-turnofevents.mp3": 2552,
	"./tts/justsaying-underestimated.mp3": 8341,
	"./tts/justsaying-understandsomething.mp3": 9409,
	"./tts/justsaying-welcome.mp3": 3791,
	"./tts/justsaying-wellplayed.mp3": 1944,
	"./tts/justsaying-whoscounting.mp3": 13,
	"./winphrase/COINS Collect Jackpot Win 03.fix.mp3": 8583,
	"./winphrase/Harp_Glissando_10b.fix.mp3": 7866,
	"./winphrase/Origami Repetika - Kind Gentle Beautiful Person.mp3": 4226,
	"./winphrase/SUCCESS CHEERS Win Cute Vocal Chime 03.fix.mp3": 6366,
	"./winphrase/SUCCESS CHIME Bells Sparkle Tune Completion 05.fix.mp3": 4686,
	"./winphrase/UI_Level_Up.fix.mp3": 1717,
	"./wrongword/Downer 111.fix.mp3": 3340,
	"./wrongword/Fail 3a.fix.mp3": 6212,
	"./wrongword/Flourish,lousymachine,trial,failure,chunky,engage.fix.mp3": 5840,
	"./wrongword/VOCAL CUTE Call Affection 03.fix.mp3": 6556,
	"./yay/220691__pep_molina__woohoo.mp3": 5664,
	"./yay/425663__camo1018__clapping.mp3": 8893
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5278;